export const knownMobileAppClientIDs = new Set([
  '0dc8049b-c627-4a13-8ec9-ba191202204d', // dev
  '8058eeb4-cff6-48f3-8bdb-d77cf9b4e612', // prod
]);
